/**
 * Fluid-Grid setup
 */
function setHeights() {
	jQuery( '.fluid-grid').each(function() {
		var grid = jQuery(this);
		var cells = jQuery( this ).find('.fluid-grid-cell');
		cells.css( 'height', 'auto' );
		
		var perRow = Math.floor( grid.outerWidth() / cells[0].getBoundingClientRect().width );
		if( perRow == null || perRow < 2 ) // If error or only one item in a row
		{
			return true;
		}
		for( var i = 0; i < cells.length; i += perRow )
		{ // Loop through rows
			var maxHeight = 0;
			var row	= cells.slice( i, i + perRow );
			// Find max height of row and set to all cells
			row.each( function()
			{
				var thisHeight = jQuery( this ).outerHeight();
				if( jQuery( this ).find(".fluid-grid-target").length ) {
					thisHeight = jQuery( this ).find(".fluid-grid-target").outerHeight();
				}
				if ( thisHeight > maxHeight )
				{
					maxHeight = thisHeight;
				}
			});
			row.each( function()
			{
				if( jQuery( this ).find(".fluid-grid-target").length ) {
					jQuery( this ).find(".fluid-grid-target").css( 'height', maxHeight );
				} else {
					jQuery( this ).css( 'height', maxHeight );
				}
			});
		}
	});
}

/**
 * RSForms No-label setup
 */
function buildNoLabelForm() {
	// jQuery("form.no-label .form-group").addClass("col-xs-12");
	jQuery("form.no-label input[type='text'], form.no-label textarea, form.no-label select, form.no-label input[type='submit'], form.no-label [id^=g-recaptcha-]").each(function() {
		// check for BS sizes
		// if(jQuery(this).attr('data-bs')) {
		// 	var bsClasses = jQuery(this).attr('data-bs');
		// 	jQuery(this).parents(".rsform-block").addClass(bsClasses);
		// }
		jQuery(this).parents('.formControls').prev().addClass("sr-only");
		jQuery(this).parents('.formControls').removeClass("col-sm-6");
		var placeholder = jQuery(this).parents('.formControls').prev().html();
		placeholder = placeholder.replace('<strong class="formRequired">(', '').replace(')</strong>', '');
		jQuery(this).attr("placeholder", placeholder);
	});
	
	// jQuery("form.no-label").each(function() {
	// 	jQuery(this).find(".form-group").wrapAll("<div class='row'></div>");
	// }) 
	// jQuery("form.no-label .form-horizontal").removeClass("form-horizontal");
	// jQuery("form.no-label .checkbox-inline").parent().removeClass("col-sm-6").addClass("col-xs-12");
	// jQuery("form.no-label .checkbox-inline").parent().prev().removeClass("col-sm-3").addClass("col-xs-12").removeClass("control-label").addClass("control-label-left");
	// jQuery("form.no-label .radio-inline").parent().removeClass("col-sm-6").addClass("col-xs-12");
	// jQuery("form.no-label .radio-inline").parent().prev().removeClass("col-sm-3").addClass("col-xs-12").removeClass("control-label").addClass("control-label-left");
	// jQuery("form.no-label .rsform-submit-button").addClass("pull-right");
	// jQuery("form.no-label .formValidation").parent().removeClass("col-sm-3").addClass("col-xs-12");
	
}

/**
 * Setup Smooth Scroll to work on links with anchor tags
 */
function setupSmoothScroll() {
	jQuery('a[href*="#"]:not([href=#])').not('[data-toggle="collapse"]').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			scrollTo(this.hash);
	  		return false;
	  	}
	});
}

/**
 * Smooth Scroll function - Scroll to tag
 */
function scrollTo(hash) {
	var target = jQuery(hash);
	if (target.length) {
  		jQuery('html,body').animate({
    		scrollTop: target.offset().top - jQuery("#mainmenu").height() - jQuery("#header-top").height() - 30
  		}, 750);
	}
}

jQuery(document).ready(function() {
	buildNoLabelForm();
	setHeights();
	setupSmoothScroll();
	
	if(jQuery("#bottom-section").length) {
		jQuery("#footer .wrapper-middle").addClass("transparency");
	}
  
	jQuery('#infiniteoptions-container').bind("DOMSubtreeModified", function(i) {
		if (jQuery('input[name="properties[site_location]"]').length && !jQuery('input[name="properties[site_location]"]').parents('div').eq(0).prev('h3').length) {
			jQuery('input[name="properties[site_location]"]').parents('div').eq(0).before('<h3>Site Information</h3>');
		} else if (jQuery('input[name="properties[owner]"]').length && !jQuery('input[name="properties[owner]"]').parents('div').eq(0).prev('h3').length) {
			jQuery('input[name="properties[owner]"]').parents('div').eq(0).before('<h3>Applicant Information</h3>');
		} else if (jQuery('input[name="properties[agreed]"]').length && !jQuery('input[name="properties[agreed]"]').parents('div').eq(0).prev('h3').length) {
			jQuery('input[name="properties[agreed]"]').parents('div').eq(0).before('<h3>Applicant Certification</h3>');
		}
	});
  	jQuery('#purchase').val('Add to Cart');
});

jQuery(window).load(function() {
	setHeights();
	// Auto smooth scroll to #tag
	if ( window.location.hash ) {
		scrollTo(window.location.hash);
	}
});

jQuery(window).resize(function() {
	setHeights();
});